export const meta = {
  id: 'M07',
  slug: 'identificar-atencao',
  title: 'Como identificar o que precisa de atenção',
  description: 'Priorize os pontos que mais precisam da sua intervenção como Mentor.',
  profile: 'mentor',
  category: 'acompanhamento',
  type: 'task',
  status: 'published',
  order: 280,
  keywords: ['atenção', 'pendências', 'metas', 'evidências', 'progresso', 'acordos', 'mentor'],
  previous: 'M06',
  next: 'M08',
  related: ['M02', 'M04', 'M09'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Como identificar o que precisa de atenção

Nem toda informação disponível exige uma intervenção. O objetivo é encontrar o ponto em que sua atuação como Mentor pode gerar mais valor agora.

## Sinais que merecem observação

- metas vencidas ou sem avanço;
- progresso parado por um período relevante;
- Evidências aguardando análise;
- Formações ou Jornadas sem evolução;
- Acordos de Mentoria ainda não executados;
- mudanças recentes que alterem prioridades;
- dificuldades que aparecem repetidamente.

## Como priorizar

<Steps>
  <Step title="Observe o conjunto">
    Use a Visão 360 para evitar decisões baseadas em um único indicador.
  </Step>
  <Step title="Procure impacto">
    Pergunte qual ponto mais interfere no objetivo de desenvolvimento do mentorado.
  </Step>
  <Step title="Escolha a intervenção mais útil">
    Nem toda pendência precisa virar cobrança. Algumas pedem reflexão, orientação, ajuste de Plano ou novo Acordo.
  </Step>
</Steps>

<Callout type="concept">
  Pergunta central do Mentor: **“Qual intervenção terá maior valor agora?”**
</Callout>

<HelpImage alt="Pendências e pontos de atenção do mentorado" pendingId="M07.1" />
